import { ViewContainerRef } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import * as i0 from "@angular/core";
var SidenavService = /** @class */ (function () {
    function SidenavService() {
        this.DEFAULT_SIDENAV_MAX_WIDTH = 40;
        this.SIDENAV_MAX_WIDTH = 50;
        this.opened$ = new BehaviorSubject(false);
        this.width$ = new BehaviorSubject(this.DEFAULT_SIDENAV_MAX_WIDTH);
    }
    SidenavService.prototype.setWidth = function (size) {
        this.width$.next(size);
    };
    SidenavService.prototype.open = function (componentFactory, width) {
        if (width === void 0) { width = this.DEFAULT_SIDENAV_MAX_WIDTH; }
        // this.sidenavContent.clear();
        this.sidenavContent.createComponent(componentFactory);
        this.opened$.next(true);
        this.width$.next(width);
    };
    SidenavService.prototype.close = function () {
        this.sidenavContent.clear();
        this.opened$.next(false);
        this.width$.next(this.DEFAULT_SIDENAV_MAX_WIDTH);
    };
    SidenavService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SidenavService_Factory() { return new SidenavService(); }, token: SidenavService, providedIn: "root" });
    return SidenavService;
}());
export { SidenavService };
